export type PropFilter = <T, K extends keyof T>(array: T[], prop: K) => Array<T[K]>;

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace angular {
        interface IFilterService {
            // eslint-disable-next-line @typescript-eslint/prefer-function-type
            (name: 'prop'): PropFilter;
        }
    }
}

/**
 * @ngdoc filter
 * @name prop
 * @module portaro.filters
 * @kind function
 *
 * @param {Array} arr Input array
 * @param {string} prop Name of property
 *
 * @return {Array} Filtered properties
 *
 * @description
 * Filter gets a property from each array element (object) and returns this property in new array.
 *
 * ```javascript
 *  type PropFilter = <T, K extends keyof T>(array: T[], prop: K) => Array<T[K]>;
 * ```
 */
export default function propFilter(): PropFilter {
    return <T, K extends keyof T>(arr: T[], prop: K): Array<T[K]> => {
        const props: Array<T[K]> = [];

        if (arr) {
            arr.forEach((item) => {
                if (typeof (item[prop]) !== 'undefined') {
                    props.push(item[prop]);
                }
            });
        }
        return props;
    };
}

propFilter.filterName = 'prop';
